import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import MaxWidthWrapper from '../../components/max-width-wrapper/MaxWidthWrapper';
import { SectionTitle } from '../../components/typography/Heading';
import { findProjectsForSchool } from '../../project/project-actions';
import ProjectCardList from '../../project/project-card-list/ProjectCardList';
import SchoolSearch from '../../project/project-edit/school/SchoolSearch/SchoolSearch';
import styles from './school-projects-for-organization-search.module.less';
import { ownerType, SCHOOL_TYPE } from '../../skolelop/school-model';

const SchoolProjectsForOrganizationSearch = ({ organizationId, organizationName, type = SCHOOL_TYPE }) => {
    const dispatch = useDispatch();
    const [school, setSchool] = useState(null);
    const [projectsForSchool, setProjectsForSchool] = useState([]);
    const [isSearchingForSchool, setIsSearchingForSchool] = useState(false);

    const noResultForSchool = !!school && !isSearchingForSchool && projectsForSchool?.length === 0;

    useEffect(() => {
        const fetchProjects = async () => {
            if (school) {
                setIsSearchingForSchool(true);
                await dispatch(findProjectsForSchool({ schoolId: school?.id, organizationId: organizationId }))
                    .then((projectIds) => {
                        if (projectIds?.length) {
                            setProjectsForSchool(projectIds.map((project) => project.id));
                        } else {
                            setProjectsForSchool([]);
                        }
                    })
                    .catch(() => {})
                    .finally(setIsSearchingForSchool(false));
            } else {
                setProjectsForSchool([]);
            }
        };

        fetchProjects();
    }, [school]);

    return (
        <MaxWidthWrapper className={styles.outerContainer}>
            <div className={styles.container}>
                <SectionTitle className={styles.header}>Finn andre spleiser til {organizationName}</SectionTitle>
                <div className={styles.searchText}>
                    Søk opp navnet på din {ownerType(type)} for å se hva som gjøres på Spleis
                </div>
                <div className={styles.schoolSearchContainer}>
                    <SchoolSearch
                        type={type}
                        selectSchoolCallback={(selectedSchool) => {
                            setSchool(selectedSchool?.school);
                        }}
                    />
                </div>
            </div>
            {isSearchingForSchool && <LoaderBar />}
            {noResultForSchool && (
                <div className={styles.noResultsInfo}>
                    <p>Det er ingen spleiser til {ownerType(type)}n enda</p>
                    <p>Opprett en spleis med ønsket aktivitet☝️</p>
                </div>
            )}
            <ProjectCardList
                projectIds={projectsForSchool}
                limit={50}
                actionInformation={`Spleiser til ${ownerType(type)}n`}
                cardTitleHeadingLevel={3}
            />
        </MaxWidthWrapper>
    );
};

export default SchoolProjectsForOrganizationSearch;
